import { render, staticRenderFns } from "./GraficoTreeMedicamento.vue?vue&type=template&id=745c1524&scoped=true&"
import script from "./GraficoTreeMedicamento.vue?vue&type=script&lang=js&"
export * from "./GraficoTreeMedicamento.vue?vue&type=script&lang=js&"
import style0 from "./GraficoTreeMedicamento.vue?vue&type=style&index=0&id=745c1524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745c1524",
  null
  
)

export default component.exports